import styled from "styled-components";

export const Main = styled.main`
  --sidebarWidth: 200px;
  --gap: 10px;
  display: flex;
`;

export const FilterDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 0 0 var(--outerMargin) 0;
  box-sizing: border-box;
  border-bottom: var(--border);
  & div {
    max-width: 20%;
    min-width: 20%;
    box-sizing: border-box;
    & + div {
      padding-left: var(--gap);
    }
  }
  & h3 {
    margin: 0 0 var(--gap) 0;
  }
  & ul {
    margin: 0 0 var(--gap) 0;
    padding: 0;
    list-style-type: none;
    & li {
      display: inline-block;
      white-space: nowrap;
      margin-right: 20px;
      &.selected {
        font-weight: bold;
      }
    }
  }
`;
